import { render } from "./BoliviaPage.vue?vue&type=template&id=05f2c74e&scoped=true"
import script from "./BoliviaPage.vue?vue&type=script&lang=js"
export * from "./BoliviaPage.vue?vue&type=script&lang=js"

import "./BoliviaPage.vue?vue&type=style&index=0&id=05f2c74e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f2c74e"]])

export default __exports__